import { configureStore } from "@reduxjs/toolkit";
import authReducer  from "./reducers/layout/authSlice";
import masterDataReducer from "./reducers/masterDataSlice";
import propertiesReducer from "./reducers/propertiesSlice";
import bookingStateReducer from "../reduxToolkit/reducers/bookingStateSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    masterData: masterDataReducer,
    properties: propertiesReducer,
    bookingState: bookingStateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
